// extracted by mini-css-extract-plugin
module.exports = {"noMatchMessage":"noMatchMessage--5841a"};